import { useEffect } from 'react';
import { useLocation } from "react-router-dom";

// Used to scroll the page to top of the body everytime the URL changes
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;